// matches libs/styles/_root-variable-colors

export const GojsVariableColor = {
  Primary100: 'primary100',
  Primary200: 'primary200',
  Primary300: 'primary300',
  Primary400: 'primary400',
  Primary500: 'primary500',
  Primary600: 'primary600',
  Primary700: 'primary700',
  Primary800: 'primary800',
  Primary900: 'primary900',
  Primary1000: 'primary1000',
  Primary1100: 'primary1100',
  Primary1200: 'primary1200',

  Gray100: 'gray100',
  Gray200: 'gray200',
  Gray300: 'gray300',
  Gray400: 'gray400',
  Gray500: 'gray500',
  Gray600: 'gray600',
  Gray700: 'gray700',
  Gray800: 'gray800',
  Gray900: 'gray900',
  Gray1000: 'gray1000',
  Gray1100: 'gray1100',
  Gray1200: 'gray1200',

  Red100: 'red100',
  Red200: 'red200',
  Red300: 'red300',
  Red400: 'red400',
  Red500: 'red500',
  Red600: 'red600',
  Red700: 'red700',
  Red800: 'red800',
  Red900: 'red900',
  Red1000: 'red1000',
  Red1100: 'red1100',
  Red1200: 'red1200',

  Orange100: 'orange100',
  Orange200: 'orange200',
  Orange300: 'orange300',
  Orange400: 'orange400',
  Orange500: 'orange500',
  Orange600: 'orange600',
  Orange700: 'orange700',
  Orange800: 'orange800',
  Orange900: 'orange900',
  Orange1000: 'orange1000',
  Orange1100: 'orange1100',
  Orange1200: 'orange1200',

  Yellow100: 'yellow100',
  Yellow200: 'yellow200',
  Yellow300: 'yellow300',
  Yellow400: 'yellow400',
  Yellow500: 'yellow500',
  Yellow600: 'yellow600',
  Yellow700: 'yellow700',
  Yellow800: 'yellow800',
  Yellow900: 'yellow900',
  Yellow1000: 'yellow1000',
  Yellow1100: 'yellow1100',
  Yellow1200: 'yellow1200',

  Lime100: 'lime100',
  Lime200: 'lime200',
  Lime300: 'lime300',
  Lime400: 'lime400',
  Lime500: 'lime500',
  Lime600: 'lime600',
  Lime700: 'lime700',
  Lime800: 'lime800',
  Lime900: 'lime900',
  Lime1000: 'lime1000',
  Lime1100: 'lime1100',
  Lime1200: 'lime1200',

  Green100: 'green100',
  Green200: 'green200',
  Green300: 'green300',
  Green400: 'green400',
  Green500: 'green500',
  Green600: 'green600',
  Green700: 'green700',
  Green800: 'green800',
  Green900: 'green900',
  Green1000: 'green1000',
  Green1100: 'green1100',
  Green1200: 'green1200',

  Teal100: 'teal100',
  Teal200: 'teal200',
  Teal300: 'teal300',
  Teal400: 'teal400',
  Teal500: 'teal500',
  Teal600: 'teal600',
  Teal700: 'teal700',
  Teal800: 'teal800',
  Teal900: 'teal900',
  Teal1000: 'teal1000',
  Teal1100: 'teal1100',
  Teal1200: 'teal1200',

  Blue100: 'blue100',
  Blue200: 'blue200',
  Blue300: 'blue300',
  Blue400: 'blue400',
  Blue500: 'blue500',
  Blue600: 'blue600',
  Blue700: 'blue700',
  Blue800: 'blue800',
  Blue900: 'blue900',
  Blue1000: 'blue1000',
  Blue1100: 'blue1100',
  Blue1200: 'blue1200',

  Pink100: 'pink100',
  Pink200: 'pink200',
  Pink300: 'pink300',
  Pink400: 'pink400',
  Pink500: 'pink500',
  Pink600: 'pink600',
  Pink700: 'pink700',
  Pink800: 'pink800',
  Pink900: 'pink900',
  Pink1000: 'pink1000',
  Pink1100: 'pink1100',
  Pink1200: 'pink1200',
} as const;

export type GojsVariableColor = (typeof GojsVariableColor)[keyof typeof GojsVariableColor];

//TODO: variableColors const should be local only to this file
export const variableColors = {
  primary100: '#fbf8ff',
  primary200: '#edebfe',
  primary300: '#d2cffd',
  primary400: '#b4b1fd',
  primary500: '#9a92fe',
  primary600: '#8672ff',
  primary700: '#7f4eff',
  primary800: '#742af5',
  primary900: '#6120d1',
  primary1000: '#4d20a7',
  primary1100: '#361d73',
  primary1200: '#311b68',
  primary100Dark: '#201542',
  primary200Dark: '#2b1a5b',
  primary300Dark: '#401e8a',
  primary400Dark: '#5620bc',
  primary500Dark: '#6e26ec',
  primary600Dark: '#7e47ff',
  primary700Dark: '#836dff',
  primary800Dark: '#948afd',
  primary900Dark: '#a8a4fd',
  primary1000Dark: '#c0bdfc',
  primary1100Dark: '#dddcfd',
  primary1200Dark: '#e4e2fd',

  gray100: '#fbf9fb',
  gray200: '#edecef',
  gray300: '#d4d3d8',
  gray400: '#b7b8bf',
  gray500: '#9d9ea7',
  gray600: '#858791',
  gray700: '#70737e',
  gray800: '#5e606b',
  gray900: '#4d505b',
  gray1000: '#3f414c',
  gray1100: '#2d2f37',
  gray1200: '#292b33',
  gray100Dark: '#1e2025',
  gray200Dark: '#26282e',
  gray300Dark: '#373943',
  gray400Dark: '#484b55',
  gray500Dark: '#5b5e69',
  gray600Dark: '#6f727d',
  gray700Dark: '#838690',
  gray800Dark: '#999aa3',
  gray900Dark: '#afafb7',
  gray1000Dark: ' #c5c5cc',
  gray1100Dark: ' #dddce1',
  gray1200Dark: ' #e9e7eb',

  red100: '#fff8f7',
  red200: '#ffe8e5',
  red300: '#ffc5be',
  red400: '#fda098',
  red500: '#f37b74',
  red600: '#e45957',
  red700: '#cf3e43',
  red800: '#b32f39',
  red900: '#942a34',
  red1000: '#76252e',
  red1100: '#76252e',
  red1200: '#4d1b20',
  red100Dark: '#361618',
  red200Dark: '#461a1e',
  red300Dark: '#672229',
  red400Dark: '#882932',
  red500Dark: '#ae2e37',
  red600Dark: '#ce3d42',
  red700Dark: '#e35755',
  red800Dark: '#f17670',
  red900Dark: '#fa948c',
  red1000Dark: '#ffb3ab',
  red1100Dark: '#ffd3ce',
  red1200Dark: '#ffe1de',

  orange100: '#fffaf7',
  orange200: '#ffe9dd',
  orange300: '#ffc8a8',
  orange400: '#ffa270',
  orange500: '#ec8348',
  orange600: '#ce6d33',
  orange700: '#af5d2a',
  orange800: '#915026',
  orange900: '#784421',
  orange1000: '#61371b',
  orange1100: '#452915',
  orange1200: '#3f2514',
  orange100Dark: '#2e1c10',
  orange200Dark: '#3a2313',
  orange300Dark: '#553119',
  orange400Dark: '#6f3f1f',
  orange500Dark: '#8d4e25',
  orange600Dark: '#ad5d2a',
  orange700Dark: '#cc6c32',
  orange800Dark: '#e87f44',
  orange900Dark: '#fa9761',
  orange1000Dark: '#ffb58c',
  orange1100Dark: '#ffd4bb',
  orange1200Dark: '#ffe2d1',

  yellow100: '#fff9e9',
  yellow200: '#ffecb1',
  yellow300: '#f6cf5a',
  yellow400: '#dbb43e',
  yellow500: '#be9b33',
  yellow600: '#a4832d',
  yellow700: '#8d6f29',
  yellow800: '#785d25',
  yellow900: '#644d1f',
  yellow1000: '#523f1b',
  yellow1100: '#3b2d16',
  yellow1200: '#352914',
  yellow100Dark: '#271e10',
  yellow200Dark: '#322714',
  yellow300Dark: '#483719',
  yellow400Dark: '#5d481e',
  yellow500Dark: '#745a24',
  yellow600Dark: '#8c6e29',
  yellow700Dark: '#a2822d',
  yellow800Dark: '#ba9732',
  yellow900Dark: '#d2ac39',
  yellow1000Dark: '#e9c24a',
  yellow1100Dark: '#fed971',
  yellow1200Dark: '#ffe79b',

  lime100: '#fff9e9',
  lime200: '#ffecb1',
  lime300: '#f6cf5a',
  lime400: '#dbb43e',
  lime500: '#be9b33',
  lime600: '#a4832d',
  lime700: '#8d6f29',
  lime800: '#785d25',
  lime900: '#644d1f',
  lime1000: '#523f1b',
  lime1100: '#3b2d16',
  lime1200: '#352914',
  lime100Dark: '#192304',
  lime200Dark: '#202c05',
  lime300Dark: '#2d3f07',
  lime400Dark: '#3b5209',
  lime500Dark: '#4a670b',
  lime600Dark: '#597d0e',
  lime700Dark: '#699310',
  lime800Dark: '#7aa912',
  lime900Dark: '#91bf2c',
  lime1000Dark: '#91bf2c',
  lime1100Dark: '#d1e5a7',
  lime1200Dark: '#e1eec5',

  green100: '#f5fcf8',
  green200: '#d6f3e2',
  green300: '#9ee1bd',
  green400: '#65cc99',
  green500: '#35b37a',
  green600: '#219a64',
  green700: '#1f8353',
  green800: '#206e45',
  green900: '#1e5c39',
  green1000: '#1a4a2e',
  green1100: '#163522',
  green1200: '#15311f',
  green100Dark: '#122418',
  green200Dark: '#142d1d',
  green300Dark: '#184128',
  green400Dark: '#1c5534',
  green500Dark: '#206b43',
  green600Dark: '#1f8253',
  green700Dark: '#219863',
  green800Dark: '#31af77',
  green900Dark: '#53c48e',
  green1000Dark: '#82d7ab',
  green1100Dark: '#b5e8cb',
  green1200Dark: '#cef0dd',

  teal100: '#f3fbfc',
  teal200: '#d7f2f4',
  teal300: '#9ddfe3',
  teal400: '#59c8d0',
  teal500: '#1cafba',
  teal600: '#1795a1',
  teal700: '#127f8c',
  teal800: '#0e6b78',
  teal900: '#0a5a67',
  teal1000: '#074855',
  teal1100: '#05343e',
  teal1200: '#053039',
  teal100Dark: '#032329',
  teal200Dark: '#042d35',
  teal300Dark: '#063f4b',
  teal400Dark: '#095360',
  teal500Dark: '#0d6875',
  teal600Dark: '#127e8b',
  teal700Dark: '#1694a0',
  teal800Dark: '#1babb6',
  teal900Dark: '#43c0ca',
  teal1000Dark: '#7dd4da',
  teal1100Dark: '#b5e6ea',
  teal1200Dark: '#cdeef1',

  blue100: '#f6fbfe',
  blue200: '#dbeffc',
  blue300: '#abdaf9',
  blue400: '#6fc2f0',
  blue500: '#38a9e0',
  blue600: '#1290c9',
  blue700: '#0c7ab2',
  blue800: '#14659b',
  blue900: '#155485',
  blue1000: '#15446d',
  blue1100: '#15314e',
  blue1200: '#152d46',
  blue100Dark: '#132132',
  blue200Dark: '#152941',
  blue300Dark: '#153b5e',
  blue400Dark: '#154e7b',
  blue500Dark: '#146397',
  blue600Dark: '#0c79b1',
  blue700Dark: '#108ec8',
  blue800Dark: '#30a5dd',
  blue900Dark: '#5cbaec',
  blue1000Dark: '#8ecef5',
  blue1100Dark: '#bee2fa',
  blue1200Dark: '#d4ebfc',

  pink100: '#fff8fc',
  pink200: '#ffe6f4',
  pink300: '#fdc3e7',
  pink400: '#f59cd8',
  pink500: '#e976c8',
  pink600: '#d952b8',
  pink700: '#c730a8',
  pink800: '#b01396',
  pink900: '#911a7d',
  pink1000: '#731c63',
  pink1100: '#511946',
  pink1200: '#4a1840',
  pink100Dark: '#35132d',
  pink200Dark: '#44173a',
  pink300Dark: '#641b56',
  pink400Dark: '#641b56',
  pink500Dark: '#ac1192',
  pink600Dark: '#c62fa7',
  pink700Dark: '#d850b7',
  pink800Dark: '#e671c6',
  pink900Dark: '#f190d3',
  pink1000Dark: '#f9b0df',
  pink1100Dark: '#fed0ec',
  pink1200Dark: '#ffdff2',

  black: '#17181c',
  white: '#ffffff',
  purple: '#f4f4fb',
};

export const GOJS_VARIABLE_COLORS: Record<GojsVariableColor, { light: string; dark: string }> = {
  [GojsVariableColor.Primary100]: { light: variableColors.primary100, dark: variableColors.primary100Dark },
  [GojsVariableColor.Primary200]: { light: variableColors.primary200, dark: variableColors.primary200Dark },
  [GojsVariableColor.Primary300]: { light: variableColors.primary300, dark: variableColors.primary300Dark },
  [GojsVariableColor.Primary400]: { light: variableColors.primary400, dark: variableColors.primary400Dark },
  [GojsVariableColor.Primary500]: { light: variableColors.primary500, dark: variableColors.primary500Dark },
  [GojsVariableColor.Primary600]: { light: variableColors.primary600, dark: variableColors.primary600Dark },
  [GojsVariableColor.Primary700]: { light: variableColors.primary700, dark: variableColors.primary700Dark },
  [GojsVariableColor.Primary800]: { light: variableColors.primary800, dark: variableColors.primary800Dark },
  [GojsVariableColor.Primary900]: { light: variableColors.primary900, dark: variableColors.primary900Dark },
  [GojsVariableColor.Primary1000]: { light: variableColors.primary1000, dark: variableColors.primary1000Dark },
  [GojsVariableColor.Primary1100]: { light: variableColors.primary1100, dark: variableColors.primary1100Dark },
  [GojsVariableColor.Primary1200]: { light: variableColors.primary1200, dark: variableColors.primary1200Dark },

  [GojsVariableColor.Gray100]: { light: variableColors.gray100, dark: variableColors.gray100Dark },
  [GojsVariableColor.Gray200]: { light: variableColors.gray200, dark: variableColors.gray200Dark },
  [GojsVariableColor.Gray300]: { light: variableColors.gray300, dark: variableColors.gray300Dark },
  [GojsVariableColor.Gray400]: { light: variableColors.gray400, dark: variableColors.gray400Dark },
  [GojsVariableColor.Gray500]: { light: variableColors.gray500, dark: variableColors.gray500Dark },
  [GojsVariableColor.Gray600]: { light: variableColors.gray600, dark: variableColors.gray600Dark },
  [GojsVariableColor.Gray700]: { light: variableColors.gray700, dark: variableColors.gray700Dark },
  [GojsVariableColor.Gray800]: { light: variableColors.gray800, dark: variableColors.gray800Dark },
  [GojsVariableColor.Gray900]: { light: variableColors.gray900, dark: variableColors.gray900Dark },
  [GojsVariableColor.Gray1000]: { light: variableColors.gray1000, dark: variableColors.gray1000Dark },
  [GojsVariableColor.Gray1100]: { light: variableColors.gray1100, dark: variableColors.gray1100Dark },
  [GojsVariableColor.Gray1200]: { light: variableColors.gray1200, dark: variableColors.gray1200Dark },

  [GojsVariableColor.Red100]: { light: variableColors.red100, dark: variableColors.red100Dark },
  [GojsVariableColor.Red200]: { light: variableColors.red200, dark: variableColors.red200Dark },
  [GojsVariableColor.Red300]: { light: variableColors.red300, dark: variableColors.red300Dark },
  [GojsVariableColor.Red400]: { light: variableColors.red400, dark: variableColors.red400Dark },
  [GojsVariableColor.Red500]: { light: variableColors.red500, dark: variableColors.red500Dark },
  [GojsVariableColor.Red600]: { light: variableColors.red600, dark: variableColors.red600Dark },
  [GojsVariableColor.Red700]: { light: variableColors.red700, dark: variableColors.red700Dark },
  [GojsVariableColor.Red800]: { light: variableColors.red800, dark: variableColors.red800Dark },
  [GojsVariableColor.Red900]: { light: variableColors.red900, dark: variableColors.red900Dark },
  [GojsVariableColor.Red1000]: { light: variableColors.red1000, dark: variableColors.red1000Dark },
  [GojsVariableColor.Red1100]: { light: variableColors.red1100, dark: variableColors.red1100Dark },
  [GojsVariableColor.Red1200]: { light: variableColors.red1200, dark: variableColors.red1200Dark },

  [GojsVariableColor.Orange100]: { light: variableColors.orange100, dark: variableColors.orange100Dark },
  [GojsVariableColor.Orange200]: { light: variableColors.orange200, dark: variableColors.orange200Dark },
  [GojsVariableColor.Orange300]: { light: variableColors.orange300, dark: variableColors.orange300Dark },
  [GojsVariableColor.Orange400]: { light: variableColors.orange400, dark: variableColors.orange400Dark },
  [GojsVariableColor.Orange500]: { light: variableColors.orange500, dark: variableColors.orange500Dark },
  [GojsVariableColor.Orange600]: { light: variableColors.orange600, dark: variableColors.orange600Dark },
  [GojsVariableColor.Orange700]: { light: variableColors.orange700, dark: variableColors.orange700Dark },
  [GojsVariableColor.Orange800]: { light: variableColors.orange800, dark: variableColors.orange800Dark },
  [GojsVariableColor.Orange900]: { light: variableColors.orange900, dark: variableColors.orange900Dark },
  [GojsVariableColor.Orange1000]: { light: variableColors.orange1000, dark: variableColors.orange1000Dark },
  [GojsVariableColor.Orange1100]: { light: variableColors.orange1100, dark: variableColors.orange1100Dark },
  [GojsVariableColor.Orange1200]: { light: variableColors.orange1200, dark: variableColors.orange1200Dark },

  [GojsVariableColor.Yellow100]: { light: variableColors.yellow100, dark: variableColors.yellow100Dark },
  [GojsVariableColor.Yellow200]: { light: variableColors.yellow200, dark: variableColors.yellow200Dark },
  [GojsVariableColor.Yellow300]: { light: variableColors.yellow300, dark: variableColors.yellow300Dark },
  [GojsVariableColor.Yellow400]: { light: variableColors.yellow400, dark: variableColors.yellow400Dark },
  [GojsVariableColor.Yellow500]: { light: variableColors.yellow500, dark: variableColors.yellow500Dark },
  [GojsVariableColor.Yellow600]: { light: variableColors.yellow600, dark: variableColors.yellow600Dark },
  [GojsVariableColor.Yellow700]: { light: variableColors.yellow700, dark: variableColors.yellow700Dark },
  [GojsVariableColor.Yellow800]: { light: variableColors.yellow800, dark: variableColors.yellow800Dark },
  [GojsVariableColor.Yellow900]: { light: variableColors.yellow900, dark: variableColors.yellow900Dark },
  [GojsVariableColor.Yellow1000]: { light: variableColors.yellow1000, dark: variableColors.yellow1000Dark },
  [GojsVariableColor.Yellow1100]: { light: variableColors.yellow1100, dark: variableColors.yellow1100Dark },
  [GojsVariableColor.Yellow1200]: { light: variableColors.yellow1200, dark: variableColors.yellow1200Dark },

  [GojsVariableColor.Lime100]: { light: variableColors.lime100, dark: variableColors.lime100Dark },
  [GojsVariableColor.Lime200]: { light: variableColors.lime200, dark: variableColors.lime200Dark },
  [GojsVariableColor.Lime300]: { light: variableColors.lime300, dark: variableColors.lime300Dark },
  [GojsVariableColor.Lime400]: { light: variableColors.lime400, dark: variableColors.lime400Dark },
  [GojsVariableColor.Lime500]: { light: variableColors.lime500, dark: variableColors.lime500Dark },
  [GojsVariableColor.Lime600]: { light: variableColors.lime600, dark: variableColors.lime600Dark },
  [GojsVariableColor.Lime700]: { light: variableColors.lime700, dark: variableColors.lime700Dark },
  [GojsVariableColor.Lime800]: { light: variableColors.lime800, dark: variableColors.lime800Dark },
  [GojsVariableColor.Lime900]: { light: variableColors.lime900, dark: variableColors.lime900Dark },
  [GojsVariableColor.Lime1000]: { light: variableColors.lime1000, dark: variableColors.lime1000Dark },
  [GojsVariableColor.Lime1100]: { light: variableColors.lime1100, dark: variableColors.lime1100Dark },
  [GojsVariableColor.Lime1200]: { light: variableColors.lime1200, dark: variableColors.lime1200Dark },

  [GojsVariableColor.Green100]: { light: variableColors.green100, dark: variableColors.green100Dark },
  [GojsVariableColor.Green200]: { light: variableColors.green200, dark: variableColors.green200Dark },
  [GojsVariableColor.Green300]: { light: variableColors.green300, dark: variableColors.green300Dark },
  [GojsVariableColor.Green400]: { light: variableColors.green400, dark: variableColors.green400Dark },
  [GojsVariableColor.Green500]: { light: variableColors.green500, dark: variableColors.green500Dark },
  [GojsVariableColor.Green600]: { light: variableColors.green600, dark: variableColors.green600Dark },
  [GojsVariableColor.Green700]: { light: variableColors.green700, dark: variableColors.green700Dark },
  [GojsVariableColor.Green800]: { light: variableColors.green800, dark: variableColors.green800Dark },
  [GojsVariableColor.Green900]: { light: variableColors.green900, dark: variableColors.green900Dark },
  [GojsVariableColor.Green1000]: { light: variableColors.green1000, dark: variableColors.green1000Dark },
  [GojsVariableColor.Green1100]: { light: variableColors.green1100, dark: variableColors.green1100Dark },
  [GojsVariableColor.Green1200]: { light: variableColors.green1200, dark: variableColors.green1200Dark },

  [GojsVariableColor.Teal100]: { light: variableColors.teal100, dark: variableColors.teal100Dark },
  [GojsVariableColor.Teal200]: { light: variableColors.teal200, dark: variableColors.teal200Dark },
  [GojsVariableColor.Teal300]: { light: variableColors.teal300, dark: variableColors.teal300Dark },
  [GojsVariableColor.Teal400]: { light: variableColors.teal400, dark: variableColors.teal400Dark },
  [GojsVariableColor.Teal500]: { light: variableColors.teal500, dark: variableColors.teal500Dark },
  [GojsVariableColor.Teal600]: { light: variableColors.teal600, dark: variableColors.teal600Dark },
  [GojsVariableColor.Teal700]: { light: variableColors.teal700, dark: variableColors.teal700Dark },
  [GojsVariableColor.Teal800]: { light: variableColors.teal800, dark: variableColors.teal800Dark },
  [GojsVariableColor.Teal900]: { light: variableColors.teal900, dark: variableColors.teal900Dark },
  [GojsVariableColor.Teal1000]: { light: variableColors.teal1000, dark: variableColors.teal1000Dark },
  [GojsVariableColor.Teal1100]: { light: variableColors.teal1100, dark: variableColors.teal1100Dark },
  [GojsVariableColor.Teal1200]: { light: variableColors.teal1200, dark: variableColors.teal1200Dark },

  [GojsVariableColor.Blue100]: { light: variableColors.blue100, dark: variableColors.blue100Dark },
  [GojsVariableColor.Blue200]: { light: variableColors.blue200, dark: variableColors.blue200Dark },
  [GojsVariableColor.Blue300]: { light: variableColors.blue300, dark: variableColors.blue300Dark },
  [GojsVariableColor.Blue400]: { light: variableColors.blue400, dark: variableColors.blue400Dark },
  [GojsVariableColor.Blue500]: { light: variableColors.blue500, dark: variableColors.blue500Dark },
  [GojsVariableColor.Blue600]: { light: variableColors.blue600, dark: variableColors.blue600Dark },
  [GojsVariableColor.Blue700]: { light: variableColors.blue700, dark: variableColors.blue700Dark },
  [GojsVariableColor.Blue800]: { light: variableColors.blue800, dark: variableColors.blue800Dark },
  [GojsVariableColor.Blue900]: { light: variableColors.blue900, dark: variableColors.blue900Dark },
  [GojsVariableColor.Blue1000]: { light: variableColors.blue1000, dark: variableColors.blue1000Dark },
  [GojsVariableColor.Blue1100]: { light: variableColors.blue1100, dark: variableColors.blue1100Dark },
  [GojsVariableColor.Blue1200]: { light: variableColors.blue1200, dark: variableColors.blue1200Dark },

  [GojsVariableColor.Pink100]: { light: variableColors.pink100, dark: variableColors.pink100Dark },
  [GojsVariableColor.Pink200]: { light: variableColors.pink200, dark: variableColors.pink200Dark },
  [GojsVariableColor.Pink300]: { light: variableColors.pink300, dark: variableColors.pink300Dark },
  [GojsVariableColor.Pink400]: { light: variableColors.pink400, dark: variableColors.pink400Dark },
  [GojsVariableColor.Pink500]: { light: variableColors.pink500, dark: variableColors.pink500Dark },
  [GojsVariableColor.Pink600]: { light: variableColors.pink600, dark: variableColors.pink600Dark },
  [GojsVariableColor.Pink700]: { light: variableColors.pink700, dark: variableColors.pink700Dark },
  [GojsVariableColor.Pink800]: { light: variableColors.pink800, dark: variableColors.pink800Dark },
  [GojsVariableColor.Pink900]: { light: variableColors.pink900, dark: variableColors.pink900Dark },
  [GojsVariableColor.Pink1000]: { light: variableColors.pink1000, dark: variableColors.pink1000Dark },
  [GojsVariableColor.Pink1100]: { light: variableColors.pink1100, dark: variableColors.pink1100Dark },
  [GojsVariableColor.Pink1200]: { light: variableColors.pink1200, dark: variableColors.pink1200Dark },
};

export const getGojsVariableColor = (color: GojsVariableColor, isDarkMode = false): string => {
  return isDarkMode ? GOJS_VARIABLE_COLORS[color].dark : GOJS_VARIABLE_COLORS[color].light;
};
